import NotificationsBell from './NotificationsBell'
export default NotificationsBell



// WEBPACK FOOTER //
// ./src/molecules/NotificationsBell/index.js